<template>
    <span>{{ email }}</span>
</template>

<script>
import stringFormatting from '@/mixins/stringFormatting'

export default {
    mixins: [stringFormatting],

    props: ['row'],

    data() {
        return {
            email: this.row.user?.support ? 'goTenna Support' : this.row.user?.email,
        }
    },
}
</script>
